import { FC, ReactNode } from "react";
import { AlertContainer } from "@/components-v2/Alert";
import { useAppBar } from "@/appBar/useAppBar";
import { AppBar } from "@/components-v2/AppBar";
import AlertMessageStore from "@/stores/AlertMessageStore";
import { Container, ContainerProps, VBox } from "@/components-v2/Box";
import { useMessageStore } from "@/stores/RootStoreContext";

type LayoutProps = {
  header?: ReactNode;
  subHeader?: ReactNode;
  alertMessageStore?: AlertMessageStore;
} & ContainerProps;

export const Layout: FC<LayoutProps> = ({
  header,
  subHeader,
  alertMessageStore,
  children,
  ...props
}) => {
  return (
    <VBox fullscreen gap={0}>
      {header}
      {alertMessageStore && <AlertContainer messageStore={alertMessageStore} />}
      <VBox grow overflowX={"hidden"} overflowY={"auto"} gap={0}>
        {subHeader}
        <Container paddingY {...props}>
          {children || <div />}
        </Container>
      </VBox>
    </VBox>
  );
};

type DefaultLayoutProps = {
  withHeader?: boolean;
} & Omit<LayoutProps, "header" | "alertMessageStore">;

const DefaultLayout: FC<DefaultLayoutProps> = ({ withHeader, ...props }) => {
  const alertMessageStore = useMessageStore();
  const appBar = useAppBar();

  const withHeaderDefault =
    !window.location.href.endsWith("/signing") &&
    !window.location.href.includes("/notice-general-meeting/") &&
    !window.location.href.includes("/notice-board-meeting/");

  const header = withHeader === undefined ? withHeaderDefault : withHeader;
  return (
    <Layout
      {...props}
      header={header && <AppBar data={appBar} />}
      alertMessageStore={alertMessageStore}
    >
      {props.children}
    </Layout>
  );
};

export default DefaultLayout;
